<template>
  <v-app>
    <v-container fluid>
      <v-row v-if="$insertAccess($route.path)">
        <v-col md="3" cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                  color="blue-grey-lighten-4"
                  class="panel-header"
              >Others Info</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form
                    @submit.prevent="submit"
                    ref="addEmployee"
                    id="addEmployee"
                >
                  <v-row class="pa-2">
                    <v-col cols="12">

                      <v-date-input
                          input-format="dd/mm/yyyy"
                          label="Sample Delivery Date"
                          density="compact"
                          prepend-icon=""
                          prepend-inner-icon="mdi-calendar"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="sample_delivery_date.value.value"
                          :error-messages="sample_delivery_date.errorMessage.value"
                          autocomplete="off"
                          clearable
                      ></v-date-input>

                      <v-autocomplete
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          v-model="sample_order_master_id.value.value"
                          :items="getSampleOrderList"
                          :item-title="(item) => `${item.code}`"
                          item-value="id"
                          @update:model-value="onSampleOrderChange"
                          :error-messages="sample_order_master_id.errorMessage.value"
                          autocomplete="off"
                          :disabled="requisitionDisable"
                          clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          Sample Order
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          v-model="customer_id.value.value"
                          :items="getCustomerMapList"
                          :item-title="item => `${item?.customer?.company_name}` ?? 'N/A'"
                          item-value="customer_id"
                          :error-messages="customer_id.errorMessage.value"
                          autocomplete="off"
                          clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          Customer Name
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>



                      <v-autocomplete
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          v-model="warehouse_id.value.value"
                          :items="getWarehouseList"
                          :item-title="(item) => `${item.name}`"
                          item-value="id"
                          :error-messages="warehouse_id.errorMessage.value"
                          autocomplete="off"
                          clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          Warehouse
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>


                      <!-- <v-date-input
                          input-format="dd/mm/yyyy"
                          label="Approximate Delivery Date"
                          density="compact"
                          prepend-icon=""
                          prepend-inner-icon="mdi-calendar"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="approximate_delivery_date.value.value"
                          :error-messages="approximate_delivery_date.errorMessage.value"
                          autocomplete="off"
                          :readonly="true"
                      ></v-date-input> -->

                      <!-- <v-date-input
                          input-format="dd/mm/yyyy"
                          label="Shiping Date"
                          density="compact"
                          prepend-icon=""
                          prepend-inner-icon="mdi-calendar"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="shipping_date.value.value"
                          :error-messages="shipping_date.errorMessage.value"
                          autocomplete="off"
                          :readonly="true"
                      ></v-date-input> -->

                      <v-textarea
                          label="Delivery Address"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="delivery_address.value.value"
                          :error-messages="delivery_address.errorMessage.value"
                          autocomplete="off"
                      ></v-textarea>

<!--                      <v-text-field-->
<!--                          label="Customer Name"-->
<!--                          density="compact"-->
<!--                          variant="outlined"-->
<!--                          bg-color="grey-lighten-4"-->
<!--                          v-model="customer_name.value.value"-->
<!--                          :error-messages="customer_name.errorMessage.value"-->
<!--                          autocomplete="off"-->
<!--                          :readonly="true"-->
<!--                      ></v-text-field>-->


                      <v-text-field
                          label="Requsition By"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="requsition_by.value.value"
                          :error-messages="requsition_by.errorMessage.value"
                          autocomplete="off"
                          :disabled="true"
                          clearable
                      ></v-text-field>

                      <v-text-field
                          label="Requsition By Mobile"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="requsition_by_mobile.value.value"
                          :error-messages="requsition_by.errorMessage.value"
                          autocomplete="off"
                          :disabled="true"
                          clearable
                      ></v-text-field>

                      <v-text-field
                          label="Requsition By Email"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="requsition_by_email.value.value"
                          :error-messages="requsition_by_email.errorMessage.value"
                          :disabled="true"
                          autocomplete="off"
                          clearable
                      ></v-text-field>

                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <v-col md="9" cols="12">
          <v-expansion-panels v-model="panel2">
            <v-expansion-panel>
              <v-expansion-panel-title
                  color="blue-grey-lighten-4"
                  class="panel-header"
              >
                Item Info
              </v-expansion-panel-title>

              <v-expansion-panel-text>
                <v-form
                    @submit.prevent="submit"
                    ref="addEmployee"
                    id="addEmployee"
                >
                  <v-row class="pt-2 justify-center">
                    <v-col cols="8">
                      <v-autocomplete
                          label="Search Prdouct Name"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          v-model="product_id.value.value"
                          :items="getProductMapList"
                          :item-title="(item) => `${item.product.code}-${item.product.name}` ?? 'N/A'"
                          item-value="product_id"
                          :error-messages="product_id.errorMessage.value"
                          @update:model-value="addCart"
                          @keydown.enter="addCart"
                          autocomplete="off"
                          clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>

                    </v-col>

                   <v-col cols="1">
                        <v-btn class="bg-primary" @click="addCart">ADD</v-btn>
                    </v-col>
                  </v-row>

                  <!-- Cart Table -->
                  <v-row class="pt-0">
                    <v-col cols="12">
                      <v-table
                          density="compact"
                          :loading="loading"
                          fixed-header
                          class="table-dotted-border-bottom"
                          style="height: 40vh; overflow-y: scroll"
                      >
                        <thead>
                        <tr>
                          <th class="text-center" style="width: 5%">SL</th>
                          <th class="text-start" style="width: 25%">Product Code</th>
                          <th class="text-left" style="width: 25%">Product Name</th>
                          <th class="text-center" style="width: 20%">Desc.</th>
                          <th class="text-center" style="width: 10%">Lot No.</th>
                          <th class="text-center" style="width: 15%">Delivery Qty.</th>
                          <th class="text-center" style="width: 15%">Unit</th>
                          <th class="text-center" style="width: 10%">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <template v-for="(item, index) in cart" v-if="cart.length > 0"  :key="index">
                          <tr @click="isGiftItem ? (expandedIndex = expandedIndex === index ? null : index) : null"
                              style="cursor:pointer; background-color: #d3f2c5;" >
                            <td class="text-center py-1">{{ index + 1 }}</td>
                            <td
                                class="text-left py-1"
                                style="white-space: normal"
                            >
                              {{ item.product_code }}
                            </td>
                            <td
                                class="text-left py-1"
                                style="white-space: normal"
                            >
                              {{ item.product_name }}
                            </td>
                            <td class="text-left py-1">
                              <v-text-field
                                  v-model="item.description"
                                  style="width: 100px"
                                  type="text"
                                  density="compact"
                                  variant="outlined"
                                  bg-color="grey-lighten-4"
                                  hide-details
                                  @click.stop
                                  @focus.stop
                              ></v-text-field>
                            </td>
                            <td class="text-left py-1">
                              <v-text-field
                                  v-model="item.lot_no"
                                  style="width: 80px"
                                  type="text"
                                  density="compact"
                                  variant="outlined"
                                  bg-color="grey-lighten-4"
                                  hide-details
                                  @click.stop
                                  @focus.stop
                              ></v-text-field>
                            </td>

                            <td class="text-right py-1">
                              <v-text-field
                                  :reverse="false"
                                  controlVariant="stacked"
                                  label=""
                                  style="width: 80px"
                                  type="number"
                                  :hideInput="false"
                                  :inset="false"
                                  :min="1"
                                  density="compact"
                                  :disabled="deliveryQtyDisable"
                                  variant="outlined"
                                  bg-color="grey-lighten-4"
                                  v-model="item.qty"
                                  @update:model-value="item.qty<0? item.qty=0 : item.qty"
                              ></v-text-field>
                            </td>
                            <td class="text-center py-1">
                              {{ item.unit_name }}
                            </td>
                            <td style="white-space: nowrap;" class="text-center py-1">
                              <v-icon
                                  size="small"
                                  color="red"
                                  class="delete-button"
                                  @click="removeFromCart(index)"
                              >
                                mdi-delete
                              </v-icon>
                              <v-btn v-if="isGiftItem" icon variant="tonal" size="small" color="primary" class="pa-1 breakdown-input">
                                <v-icon color="blue">mdi-gift-open</v-icon>
                              </v-btn>
                              <v-icon v-if="isGiftItem" size="small">
                                {{ expandedIndex === index ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                              </v-icon>
                            </td>
                          </tr>

                          <tr class="pa-0" >
                            <td colspan="100%" class="pa-0" style="height: 0px;">
                              <v-expand-transition >
                                <div v-if="expandedIndex === index" :key="'expand-' + index" class="d-flex flex-column">

                                  <v-table density="compact" :loading="loading" fixed-header
                                           class="table-dotted-border-bottom">
                                    <thead>
                                    <tr>
                                      <th class="text-center" style="width: 5%">SL</th>

                                      <th class="text-left" style="width: 30%">
                                        Product
                                      </th>

                                      <th class="text-center" style="width: 10%">Unit</th>

                                      <th class="text-left" style="width: 10%">
                                        Quantity
                                      </th>

                                      <th class="text-left" style="width: 15%">
                                        Rate
                                      </th>

                                      <th class="text-center" style="width: 15%">
                                        Amount
                                      </th>
                                      <th class="text-center" style="width: 20%">
                                        Desc.
                                      </th>
                                      <th class="text-center" style="width: 10%">
                                        Lot No.
                                      </th>
                                      <th class="text-right" style="width: 5%">Action</th>
                                    </tr>
                                    </thead>

                                  </v-table>

                                </div>
                              </v-expand-transition>
                            </td>
                          </tr>

                        </template>
                        </tbody>
                      </v-table>
                    </v-col>
                  </v-row>
                  <!-- Close Cart Table -->

                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-row class="pt-2">
                      <v-col cols="8">
                        <div class="d-flex justify-space-between align-center mb-2">
                          <v-label class="text-subtitle-1 font-weight-bold">
                            Description
                          </v-label>
                        </div>

                        <Ckeditor
                            :editor="ClassicEditor"
                            v-model="remarks.value.value"
                            :config="editorConfig"
                        />
                      </v-col>
                      <v-col cols="4">
                        <v-layout class="justify-end">
                          <v-btn
                              class="bg-grey-darken-1 me-2"
                              variant="flat"
                              @click="submitForm(0)"
                          >DRAFT</v-btn>
                          <v-btn
                              class="bg-primary"
                              variant="flat"
                              @click="submitForm(1)"
                          >POST</v-btn>
                        </v-layout>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import { useRouter } from "vue-router";
import { getCompanyInfo } from '@/plugins/helpers'
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {Ckeditor} from "@ckeditor/ckeditor5-vue";

export default {
  components: {
    Ckeditor
  },
  data: () => ({
    expandedIndex: null,
    isFreeItem:false,
    isGiftItem:false,
    isEntryMode: true,
    panel: [0],
    panel2: [0],
    loading: false,
    errorMessages: "",
    visible: false,
    deliveryQtyDisable: false,
    requisitionDisable: false,
    search: "",
    selectedImage: null,
    photo_imageFile: "",
    preview: "/src/assets/no_preview.png",
    cart: [],
  }),
  watch: {},
  created() {
    const id = this.$route.query.id;
    if(id) {
      this.type='sample_order_for_delivery_edit'
    }else {
      this.type= 'sample_order_for_delivery'
    }
    // if (this.$store.getters.getHrmDepartmentList.length === 0) {
      this.$store.dispatch("getHrmDepartmentList");
    // }
    // if (this.$store.getters.getWarehouseList.length === 0) {
      this.$store.dispatch("getWarehouseList");
    // }
    // if (this.$store.getters.getCustomerMapList.length === 0) {
      this.$store.dispatch("getCustomerMapList");
    // }
    // if (this.$store.getters.getProductMapList.length === 0) {
      this.$store.dispatch("getProductMapList");
    // }
    this.$store.dispatch("getSampleOrderList", { type: this.type });
  },
  computed: {
    getCustomerMapList() {
      return this.$store.getters.getCustomerMapList;
    },
    getHrmDepartmentList() {
      return this.$store.getters.getHrmDepartmentList;
    },
    getWarehouseList() {
      return this.$store.getters.getWarehouseList;
    },
    getSampleOrderList() {
      return this.$store.getters.getSampleOrderList;
    },
    getProductMapList() {
      let products = this.$store.getters.getProductMapList;
      return products.filter(
          (item) =>
              item.branch_id == this.$store.getters.getAuthUser.branch_id &&
              item.status == 1
      );

    },
  },
  methods: {
    addCart() {
      let cartInd = this.cart.findIndex(
          (p) => p.product_id == this.product_id.value.value
      );

      if (this.product_id.value.value == null) {
        toast.error("Please select a Product");
        this.cartReset();
        return false;
      }

      if (cartInd > -1) {
        toast.error("Product already added in cart");
        this.cartReset();
        return false;
      }

      let product = this.getProductMapList.find(
          (item) => item.product_id == this.product_id.value.value
      );
      product = product.product;

      let item = {
        product_id: this.product_id.value.value,
        product_name: product.name,
        product_code: product.code,
        qty: 1,
        unit_id: product.unit_id,
        unit_name: product.unit.name,
      };

      this.cart.push(item);
      this.$nextTick(() => {
        this.cartReset();
      });
    },
    removeFromCart(index) {
      if (confirm("Are You Sure?")) {
        this.cart.splice(index, 1);
      }
    },
    cartReset() {
      this.product_id.value.value = null;
    },

    async onSampleOrderChange(selectedId) {
      if (!selectedId) {
        this.customer_id.value.value = null;
        this.delivery_address.value.value = "";
        this.cart = [];
        return;
      }

      try {
        const response = await this.$store.dispatch("getSampleOrderById", selectedId);

        this.customer_id.value.value = response.customer_id || response.customer?.id || null;
        this.delivery_address.value.value = response.delivery_address || "";
        this.shipping_date.value.value = response.shipping_date || null;
        this.cart = [];

        (response.details || []).forEach((item) => {
          if (item.product) {
            this.cart.push({
              product_id: item.product_id,
              product_name: item.product.name || "",
              product_code: item.product.code || "",
              delivery_qty: item.delivery_qty || 0,
              available_qty: item.product.available_inventory_qty || 0,
              qty: item.quantity || 0,
              unit_id: item.product.unit?.id || "",
              unit_name: item.product.unit?.name || "",
              description: item.description || "",
              lot_no: item.lot_no || "",
            });
          }
        });
      } catch (error) {
        console.error("Error loading sample order:", error);
      }
    }
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        // requisition_date: yup.date().required().label("Requisition Date"),
        sample_delivery_date: yup.date().nullable().label("Invoice Delivery Date"),
        sample_order_master_id: yup.number().positive().integer().required().label("Sample Order"),
        // department_id: yup.number().positive().integer().required().label("Department Name"),
        warehouse_id: yup.number().positive().integer().required().label("Designation Name"),
      }),
    });
    const sample_delivery_master_id = useField("sample_delivery_master_id");
    const sample_order_master_id = useField("sample_order_master_id");
    const requisition_id = useField("requisition_id");
    const customer_id = useField("customer_id");
    const require_date = useField("require_date");
    const product_id = useField("product_id");
    const pr_status = useField("pr_status");
    const status = useField("status");
    const employee_id = useField("employee_id");
    const department_id = useField("department_id");
    const warehouse_id = useField("warehouse_id");

    const requisition_date = useField("requisition_date");
    const sample_delivery_date = useField("sample_delivery_date");
    const remarks = useField("remarks");
    const requsition_by = useField("requsition_by");
    const requsition_by_mobile = useField("requsition_by_mobile");
    const requsition_by_email = useField("requsition_by_email");
    const approximate_delivery_date = useField("approximate_delivery_date");
    const shipping_date = useField("shipping_date");
    const delivery_address = useField("delivery_address");
    // const customer_name = useField("customer_name");




    const errorMessages = ref("");
    const cart = ref([]);
    const loading = ref("");
    const buttonText = ref("");
    buttonText.value = "Save";
    const store = useStore();
    const router = useRouter();

    const currentStatus = ref(0);

    const submitForm = (status) => {
      currentStatus.value = status;
      submit();
    };

    const submit = handleSubmit((values) => {
      values.status = currentStatus.value;
      values.cart = cart.value
      console.log(values)
      store
          .dispatch("saveUpdateInvSampleDelivery", values)
          .then((response) => {
            resetForm();
            buttonText.value = "Save";
            cart.value = [];
            toast.success(response.data.message, {
              timeout: 3000,
            });
            setTimeout(() => {
              router.push({ name: "sample-delivery-records" });
            }, 2000);
          })
          .catch((error) => {
            toast.error(error.response.data.message);
          });
    });
    return {
      submit,
      submitForm,
      sample_delivery_master_id,
      sample_order_master_id,
      requisition_id,
      product_id,
      customer_id,
      requisition_date,
      sample_delivery_date,
      require_date,
      remarks,
      cart,
      requsition_by,
      requsition_by_mobile,
      requsition_by_email,
      pr_status,
      status,
      errorMessages,
      employee_id,
      department_id,
      warehouse_id,
      buttonText,
      loading,
      approximate_delivery_date,
      shipping_date,
      delivery_address,
      // customer_name,
      getCompanyInfo,
      ClassicEditor,
      editorConfig: {
        toolbar: {
          items: [
            "heading", "|", "bold", "italic", "underline", "|", "link", "bulletedList", "numberedList", "|", "outdent", "indent", "|", "blockQuote", "|", "undo", "redo",
          ],
        },
        language: "en",
      },
    };
  },
  mounted() {

    this.isGiftItem = getCompanyInfo()?.is_gift_item ?? false;
    this.isFreeItem = getCompanyInfo()?.is_free_item ?? false;

    this.pr_status.value.value = "1";
    this.status.value.value = 1;
    this.employee_id.value.value = "";
    let user = this.$store.getters.getAuthUser;
    this.requsition_by.value.value = this.$store.getters.getAuthUser.full_name;
    this.requsition_by_mobile.value.value =
        this.$store.getters.getAuthUser.mobile;
    this.requsition_by_email.value.value =
        this.$store.getters.getAuthUser.email;

    // Set require_date to today
    const today = new Date().toISOString().slice(0, 10); // 'YYYY-MM-DD'
    this.require_date.value.value = today;
    this.requisition_date.value.value = today;

    const id = this.$route.query.id;
    if (id) {
      this.$store.commit("SET_LOADING", { color: "primary" });

      this.$nextTick(() => {
        this.$store
            .dispatch("getInvSampleDeliveryById", id)
            .then((data) => {
              this.isEntryMode = false;
              this.requisitionDisable = true;
              let sample = data;

              this.sample_delivery_master_id.value.value = sample.id;
              this.sample_order_master_id.value.value = sample.sample_order_master_id;
              this.sample_delivery_date.value.value = sample.sample_delivery_date
                  ? new Date(sample.sample_delivery_date)
                  : new Date();
              this.warehouse_id.value.value = sample.warehouse.id;
              this.delivery_address.value.value = sample.delivery_address;
              this.customer_id.value.value = sample.customer_id;
              this.status.value.value = sample.status || 1;
              this.cart.value = [];

              // Insert items one by one
              (sample.sample_delivery_details || []).forEach((item) => {
                this.cart.push({
                  product_id: item.product_id,
                  product_name: item.product?.name || "",
                  product_code: item.product?.code || "",
                  available_qty: item.product?.available_inventory_qty,
                  delivery_qty: item?.invoice_detail?.delivery_qty || 0,
                  free_qty: item?.free_qty|| 0,
                  qty: item.qty,
                  unit_id: item.product.unit?.id || "",
                  unit_name: item.product.unit?.name || "",
                  description: item.remarks || "",
                  lot_no: item.lot_no || "",
                });
                // if(item.qty === item.invoice_detail.approval_qty) {
                //     this.deliveryQtyDisable = true;
                // }else{
                //     this.deliveryQtyDisable = false;
                // }
              });
              this.remarks.value.value = sample.remarks
                  ? sample.remarks
                  : "";
              this.$store.commit("UNSET_LOADING");
            })
            .catch((error) => {
              this.$store.commit("UNSET_LOADING");
              console.error("Failed to fetch sample:", error);
            });
      });
    } else {
      this.sample_delivery_date.value.value = new Date();
      this.isEntryMode = true;
      this.remarks.value.value = `
                <ul>
                    <li>The supplied product must be <strong>brand new, genuine.</strong></li>
                    <li>Payment: Account pay cheque &ndash; after delivery of Goods</li>
                    <li>Excluding VAT-TAX</li>
                    <li>The warranty shall be <strong>1 years limited warranty</strong> as specified by the manufacturer</li>
                    <li>Delivery shall be made to the location specified by <strong>Remex ingredient Solution.</strong></li>
                </ul>
                <p>Please take necessary action in this regard.</p>
              `
    }
  },
};
</script>
